import { render, staticRenderFns } from "./RouteSegments.vue?vue&type=template&id=c2dd78a8&scoped=true"
import script from "./RouteSegments.vue?vue&type=script&lang=js"
export * from "./RouteSegments.vue?vue&type=script&lang=js"
import style0 from "./RouteSegments.vue?vue&type=style&index=0&id=c2dd78a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2dd78a8",
  null
  
)

export default component.exports